import engine from './engines/gsap';

function getObserverOptions(el, defaultOffset, suffix) {
  const key = suffix ? `animateOffset${suffix}` : 'animateOffset';
  const off = el.dataset[key] ?? el.dataset.animateOffset ?? defaultOffset;
  if (!off) return {};
  const str = String(off).trim();
  if (str.endsWith('%')) return { rootMargin: `0px 0px -${str} 0px` };
  const px = Number(str);
  return Number.isNaN(px) ? {} : { rootMargin: `0px 0px -${px}px 0px` };
}

function getBreakpointSuffixCamel() {
  // Tailwind-like breakpoints: sm 640, md 768, lg 1024, xl 1280
  if (window.matchMedia('(min-width: 1280px)').matches) return 'Xl';
  if (window.matchMedia('(min-width: 1024px)').matches) return 'Lg';
  if (window.matchMedia('(min-width: 768px)').matches) return 'Md';
  if (window.matchMedia('(min-width: 640px)').matches) return 'Sm';
  return '';
}

export function initViewportAnimations(
  selector = '[data-animate]',
  { defaultOffset = '100px', root = document } = {}
) {
  if (!root || typeof root.querySelectorAll !== 'function') return;

  const els = Array.from(root.querySelectorAll(selector)).filter(
    el => el.dataset.pfyAnimateObserved !== 'true'
  );
  if (!els.length) return;

  const buckets = new Map();

  els.forEach(el => {
    el.dataset.pfyAnimateObserved = 'true';

    const suffix = getBreakpointSuffixCamel();
    const options = getObserverOptions(el, defaultOffset, suffix);
    const key = JSON.stringify(options);
    if (!buckets.has(key)) {
      buckets.set(key, {
        observer: new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            obs.unobserve(entry.target);
            const target = entry.target;
            const currentSuffix = getBreakpointSuffixCamel();
            // Allow disabling per breakpoint: data-animate-off, data-animate-off-md, etc.
            const offKey = currentSuffix ? `animateOff${currentSuffix}` : 'animateOff';
            const isOff = (target.dataset[offKey] ?? target.dataset.animateOff) === 'true';
            if (isOff) return;

            const presetKey = currentSuffix ? `animate${currentSuffix}` : 'animate';
            const preset = target.dataset[presetKey] || target.dataset.animate || 'fade-in';
            engine.play(target, preset, { datasetSuffix: currentSuffix });
          });
        }, options),
        els: [],
      });
    }
    buckets.get(key).els.push(el);
  });

  buckets.forEach(({ observer, els }) => els.forEach(el => observer.observe(el)));
}

export default { initViewportAnimations };
